// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import Icon from './form/Icon';
import { useGlobalState } from './globalState/GlobalStateProvider';

const Wrapper = styled.div`
    display: flex;
    position: relative;
`
const Notif = styled.div`
    position: absolute;
    top: -1em;
    right: -2em;

    font-size: 0.7rem;

    color: ${({ theme }) => theme.mobile.white};
    border-radius: 50%;
    font-weight: 700;
    background-color: red;
    line-height: 1rem;
    width: 1rem;
    height: 1rem;
`

const NotificationBubble = ({ ...props }) => {
    const { state: {
        active_user,
    } } = useGlobalState();

    if (!active_user.notifications || active_user.notifications.unread === 0) return null;

    return (
        <Wrapper {...props}>
            <Notif>
                {active_user.notifications.unread}
            </Notif>
        </Wrapper>
    );
}

export default NotificationBubble;